import { useState } from "react";

const useFileList = (
  inputFile: File | undefined
): [
  File[],
  (e: React.ChangeEvent<HTMLInputElement>) => void,
  (index: number) => void
] => {
  const [files, setFiles] = useState<File[]>(inputFile ? [inputFile] : []);

  const removeFileFromList = (index: number) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const addFileToList = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!(e.target.files && e.target.files.length > 0)) {
      return;
    }

    const newFile = e.target.files[0];
    setFiles((prev) => [...prev, newFile]);
  };

  return [files, addFileToList, removeFileFromList];
};

export default useFileList;
